module.exports = __webpack_public_path__ + "static/fcra-2016-17-q1-e1bc951a97e70bc58c5c7e79249185df.pdf";